export default {
  title: "Password Reset",
  newPassword: "New password",
  submit: "Submit",
  errorMessage: "Could not change password"
};
